
import { inject } from '@angular/core';
import { AuthService } from '../Services/auth.service';

export function initializeApp() {
  const authService = inject(AuthService);
  return authService.initializeAuth();
}
